import React from 'react';

import { useCompanyCountryExposure } from '~/react-query-hooks/knowledge-graph/useKnowledgeGraph';

import { GeographicExposureTable } from '../components/GeographicExposureTable';
import { useGeographicDrawer } from '../drawers/useGeographicDrawer';

export interface CountryExposureTabProps {
  entityTag: string;
}

export const CountryExposureTab = ({ entityTag }: CountryExposureTabProps) => {
  const { openCountry } = useGeographicDrawer();

  const { data, isFetching } = useCompanyCountryExposure({
    entityTag: entityTag,
    enabled: !!entityTag,
  });

  return (
    <GeographicExposureTable
      mode="country"
      data={data}
      isFetching={isFetching}
      onRowClick={openCountry}
    />
  );
};
